import axios from 'axios';
import logger from '../utils/logger';

/**
 * AMAÇ: Tüm API çağrılarında kullanılan merkezi Axios istemcisi
 * Token yönetimi ve hata loglama burada yapılır
 */

const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_URL || 'http://localhost:5001',
  timeout: 10000,
  headers: { 'Content-Type': 'application/json' },
});

// Her istekte token'ı otomatik ekle
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('streak_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  logger.debug(`→ ${config.method?.toUpperCase()} ${config.url}`);
  return config;
});

// Her yanıtta loglama ve hata yönetimi
apiClient.interceptors.response.use(
  (response) => {
    logger.debug(`← ${response.status} ${response.config.url}`);
    return response;
  },
  (error) => {
    const status = error.response?.status;
    const url = error.config?.url;
    const message = error.response?.data?.message || error.message;

    logger.error(`API Hatası ${status}`, { url, message });

    // Token süresi dolmuşsa login'e yönlendir — SADECE token ile yapılmış bir istek
    // 401 dönerse (oturumu düşmüş kullanıcı). Login/register gibi anonim isteklerde
    // (ör. yanlış şifre) Authorization header'ı hiç yoktur; bunları burada yakalayıp
    // sayfayı zorla yenilemek, formdaki veriyi ve component'in kendi gösterdiği hata
    // mesajını (ör. "Email veya şifre hatalı") siliyordu — o durumda component'in kendi
    // catch bloğu hatayı zaten düzgün gösteriyor, buraya hiç dokunmamalı.
    if (status === 401 && error.config?.headers?.Authorization) {
      localStorage.removeItem('streak_token');
      window.location.href = '/login';
    }

    return Promise.reject(error);
  }
);

export default apiClient;
